import clsx from 'clsx';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { useIsWindowMethodLoaded } from 'helpers';

import { Accessibility } from './icons/Accessibility';
import { LocaleContext } from './rebrand/Layout';

const BtnAccessibility = ({ className, ...props }: React.ComponentPropsWithRef<'button'> & { className?: string }) => {
  const locale = useContext(LocaleContext);
  const isScriptLoaded = useIsWindowMethodLoaded('interdeal');

  return (
    <button
      lang={locale}
      className={twMerge(clsx('fixed left-10 top-1/2 z-belowNav block -translate-y-1/2', !isScriptLoaded && 'hidden'))}
      aria-label={
        {
          en: `Open accessibility options`,
          fr: `Options d'accessibilité ouvertes`,
        }[locale]
      }
      onClick={() => (window as any)?.interdeal?.a11y?.openMenu()}
      {...props}
    >
      <div className="rounded-full bg-grey-250 p-4">
        <Accessibility className="fill-white" />
      </div>
    </button>
  );
};

export default BtnAccessibility;
